import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const HorizontalBar = styled.div<{ $isEmpty?: boolean }>`
  display: flex;
  height: 2rem;
  border-radius: 0.6rem;
  background: transparent;

  ${({ $isEmpty }) =>
    $isEmpty &&
    css`
      border: 1px dashed ${vars.colors.grey80};
    `}
`;

export const HorizontalBarSegment = styled.div<{ $color: string; $isFirst: boolean; $isLast: boolean }>`
  cursor: help;
  width: 100%;
  height: 100%;

  background: ${({ $color }) => $color};

  ${({ $isLast }) =>
    !$isLast &&
    css`
      border-right: 2px solid #2c2c2e54;
    `}

  border-radius: ${({ $isFirst, $isLast }) =>
    $isFirst && $isLast ? "0.6rem" : $isFirst ? "0.6rem 0 0 0.6rem" : $isLast ? "0 0.6rem 0.6rem 0" : "0"};
`;
